;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { createLogger } from '@qogita/logger'
import { consoleTransport } from '@qogita/logger/transport/console-transport'
import { createLogTransport } from '@qogita/observability/log-transport'
import { NEXT_PUBLIC_OBSERVABILITY_ENABLED } from 'src/core/observability/config'
import {
  NEXT_PUBLIC_OBSERVABILITY_ENV,
  NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
} from 'src/core/observability/constants.browser'
import { z } from 'zod'

const NEXT_PUBLIC_BROWSER_LOG_LEVEL = z
  .enum(['error', 'warn', 'info', 'debug'])
  .optional()
  .parse(process.env.NEXT_PUBLIC_BROWSER_LOG_LEVEL)

export const browserLogger = createLogger({
  environment: NEXT_PUBLIC_OBSERVABILITY_ENV,
  version: NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  transports: [
    createLogTransport({
      enabled: NEXT_PUBLIC_OBSERVABILITY_ENABLED,
      fallback: consoleTransport,
    }),
    NEXT_PUBLIC_OBSERVABILITY_ENABLED ? undefined : consoleTransport,
  ],
  minLevel: NEXT_PUBLIC_BROWSER_LOG_LEVEL,
  name: 'default-browser-logger',
})

export function logErrorBoundaryError(
  error:
    | (Error & { digest?: string; fingerprint?: string; details?: unknown })
    | unknown,
) {
  if (!(error instanceof Error)) {
    browserLogger.error('ErrorBoundary: Unknown error', {
      error: {
        value: error,
      },
      is_error_boundary: true,
      error_source: 'client',
    })
    return
  }

  return browserLogger.error(error, {
    is_error_boundary: true,
    error_source: 'digest' in error ? 'server' : 'client',
  })
}
